import React, { useState, useEffect } from 'react'
import { Box, IconButton, Typography, Divider, Button } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DeleteIcon from '@mui/icons-material/Delete';
import EmpModalContainer from '../../../containers/common/form/modal/EmpModalContainer';


const TechAddUsersForm = ({ formik, ccUsers, workUsers, addUsers, removeUser }) => {
    const [open, setOpen] = useState(false);
    const [type, setType] = useState(null);
    const [roleTyp, setRoleTyp] = useState("");
    const [title, setTitle] = useState(null);
    const [multi, setMulti] = useState(false);




    const openEmpModal = (type) => {
        setOpen(true);
        setType(type);

        if (type === 'cc') {
            setTitle("참조자 선택 - 사원 리스트");
            setMulti(true);
            setRoleTyp("");
        } else {
            setTitle("작업자 선택 - 사원 리스트");
            setMulti(true);
            setRoleTyp("TECH");
        }
    }

    const handleClose = () => {
        setRoleTyp("");
        setOpen(false);
        setType(null);
        setTitle(null);
        setMulti(false);
    }

    const selectedEmployee = (emp) => {
        addUsers(type, emp);
    }

    const removeItem = (type, emp) => {
        removeUser(type, emp);
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Button variant="outlined" color="secondary" onClick={() => openEmpModal('workers')}>작업자 선택</Button>
            </Box>
            {workUsers.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="subtitle2" component="div">선택된 작업자가 없습니다.</Typography>
                </Box>
            ) : (
                <TableContainer component={Box}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>No</TableCell>
                                <TableCell>부서명</TableCell>
                                <TableCell>이름</TableCell>
                                <TableCell>직급</TableCell>
                                <TableCell>연락처</TableCell>
                                <TableCell>이메일</TableCell>
                                <TableCell>삭제</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {workUsers.map((usr, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{usr?.dptNm}</TableCell>
                                        <TableCell>{usr?.usrNm}</TableCell>
                                        <TableCell>{usr?.gradeNm}</TableCell>
                                        <TableCell>{usr?.emlAddr}</TableCell>
                                        <TableCell>{usr?.telNo}</TableCell>
                                        <TableCell><IconButton size="small" onClick={() => removeItem('workers', usr)}><DeleteIcon /></IconButton></TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}


            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Box>
                    <Button variant="outlined" color="secondary" onClick={() => openEmpModal('cc')}>참조자 선택</Button>
                </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
            {ccUsers.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="subtitle2" component="div">선택된 참조자가 없습니다.</Typography>
                </Box>
            ) : (
                <TableContainer component={Box}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>No</TableCell>
                                <TableCell>부서명</TableCell>
                                <TableCell>이름</TableCell>
                                <TableCell>직급</TableCell>
                                <TableCell>연락처</TableCell>
                                <TableCell>이메일</TableCell>
                                <TableCell>삭제</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {ccUsers.map((usr, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{usr?.dptNm}</TableCell>
                                        <TableCell>{usr?.usrNm}</TableCell>
                                        <TableCell>{usr?.gradeNm}</TableCell>
                                        <TableCell>{usr?.emlAddr}</TableCell>
                                        <TableCell>{usr?.telNo}</TableCell>
                                        <TableCell><IconButton size="small" onClick={() => removeItem('cc', usr)}><DeleteIcon /></IconButton></TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <EmpModalContainer
                roleTyp={roleTyp}
                title={title}
                multi={multi}
                open={open}
                handleClose={handleClose}
                selectedEmployee={selectedEmployee}
            />
        </Box>
    )
}


export default TechAddUsersForm